import { Button, Result } from 'antd';
import { ResultStatusType } from 'antd/es/result';
import React from 'react';

const ERROR_KEY = '__ERROR_TIMESTAMP__'; // 错误时间戳存储键
const ERROR_INTERVAL = 30 * 1000; // 30 秒节流刷新

// 错误提示配置数组（按顺序匹配）
const ERROR_DISPLAY_CONFIG: {
  status?: ResultStatusType;
  pattern: RegExp;
  title: string;
  subTitle: string;
}[] = [
  // 插件引起的错误，显示告警页面
  {
    status: "warning",
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    pattern: /Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node\./i,
    title: '出现了意外',
    subTitle: '当前内容由于浏览器插件的干扰，导致偶发的显示异常，请尝试关闭相关插件或刷新页面',
  },
  // 版本引起的错误，就显示该提示页面
  {
    // Unexpected token '<'
    // Loading chunk 81dd38bd failed.
    pattern: /Loading chunk|Unexpected token '</i,
    title: '版本更新了',
    subTitle: '有新版本内容发布，请刷新页面获取最新内容',
  },
];

// 其它问题因此的错误，就显示错误页面
const DEFAULT_ERROR_INFO = {
  status: "500",
  title: '错误',
  subTitle:
    '当前页面发生了错误，已经上报！工程师们正在加急处理中，稍后请刷新页面，有疑问请联系管理员。',
};

// 根据错误信息返回匹配的提示内容
const getErrorInfo = (error: Error) => {
  const message = error?.message || '';
  const matched = ERROR_DISPLAY_CONFIG.find((cfg) => cfg.pattern.test(message));
  return matched || DEFAULT_ERROR_INFO;
};

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);

    // 错误上报（可根据环境判断）
    if (window.ENVIRONMENT_TYPE && window.aliLogger?.error) {
      window.aliLogger.error(error, errorInfo);
    }

    // 节流处理刷新
    const timestampStr = sessionStorage.getItem(ERROR_KEY);
    const now = Date.now();

    if (!timestampStr || now - parseInt(timestampStr, 10) > ERROR_INTERVAL) {
      sessionStorage.setItem(ERROR_KEY, now.toString());
      window.location.reload();
    }
  }

  // 处理刷新页面
  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const errorInfo = getErrorInfo(this.state.error || new Error('未知错误'));

      return (
        <Result
          status={errorInfo?.status as ResultStatusType}
          title={errorInfo.title}
          subTitle={errorInfo.subTitle}
          extra={
            <Button type="primary" onClick={this.handleReload}>
              刷新页面
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
